import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(4),
  },
  label: {
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
